import React from 'react'

export default () => (
  <div>
    <h1>Forgot Password</h1>
  </div>
)
